const { writeRequirements } = require('@sstdev/lib_metadata-config');
const { resolveRequestSchema } = require('./resolveRequestSchema');

/** A POST must satisfy a complete create form, without inheriting edit-only requirements. */
function createRequestSchema(schemaName, schemas, rawSchemas) {
    const schema = schemas[schemaName];
    if (!schema) return { type: 'object' };
    const result = { $ref: `#/components/schemas/${schemaName}` };
    const alternatives = rawSchemas[schemaName]?.['x-writeRequirements']?.create;
    if (!alternatives?.length) return result;

    const required = writeRequirements.common(alternatives);
    if (required.some(field => !schema.required?.includes(field))) result.required = required;
    const branches = alternatives.map(form => {
        const properties = arrayConstraintOverrides(schema.properties || {}, form.properties, schemas);
        return { required: form.required, ...(Object.keys(properties).length ? { properties } : {}) };
    });
    if (branches.length > 1) result.anyOf = branches;
    else if (branches[0].properties) result.properties = branches[0].properties;
    return result;
}

function arrayConstraintOverrides(sharedProperties, bounds, schemas) {
    return Object.fromEntries(
        Object.entries(bounds).flatMap(([name, constraints]) => {
            if (!sharedProperties[name]) return [];
            const shared = resolveRequestSchema(sharedProperties[name], schemas);
            const differentItems =
                constraints.minItems !== undefined && (shared.minItems ?? 0) !== constraints.minItems;
            const differentValues =
                shared.items?.type === 'string' &&
                constraints.items &&
                JSON.stringify(writeRequirements.stringItemConstraints(shared.items)) !==
                    JSON.stringify(constraints.items);
            const properties = arrayConstraintOverrides(shared.properties || {}, constraints.properties || {}, schemas);
            const itemSchema = constraints.items?.properties
                ? resolveRequestSchema(shared.items || {}, schemas)
                : undefined;
            const itemProperties = itemSchema
                ? arrayConstraintOverrides(itemSchema.properties || {}, constraints.items.properties, schemas)
                : {};
            if (
                !differentItems &&
                !differentValues &&
                !Object.keys(properties).length &&
                !Object.keys(itemProperties).length
            )
                return [];
            return [
                [
                    name,
                    {
                        ...shared,
                        ...(constraints.minItems !== undefined ? { minItems: constraints.minItems } : {}),
                        ...(Object.keys(properties).length
                            ? { properties: { ...shared.properties, ...properties } }
                            : {}),
                        ...(Object.keys(itemProperties).length
                            ? { items: { ...itemSchema, properties: { ...itemSchema.properties, ...itemProperties } } }
                            : {}),
                        ...(differentValues
                            ? { items: writeRequirements.withStringItemConstraints(shared.items, constraints.items) }
                            : {})
                    }
                ]
            ];
        })
    );
}

module.exports = { createRequestSchema };
